import React, { Component, ReactNode } from "react";
import {
  StyleType,
  WheelData,
} from "react-custom-roulette/dist/components/Wheel/types";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import pointer from "../../../assets/images/wheel-pointer.svg";
import FirebaseKey from "../../../components/FirebaseKey/FirebaseKey";
import Loading from "../../../components/Loading/Loading";
import Wheel4p from "../../../components/Wheel4p/Wheel4p";
import { WheelInitData } from "../../../core/models/custom/wheelInitData";
import { HashDetailDto } from "../../../core/models/dtos/hashDetail.dto";
import { OfferDto } from "../../../core/models/dtos/offer.dto";
import { ConsumeHashRequest } from "../../../core/models/requests/consumeHash.request";
import FirebaseService from "../../../core/services/firebaseService/firebase.service";
import { consumeHash } from "../../../core/services/hashService/consumeHash/actions";
import { ConsumeHashState } from "../../../core/services/hashService/consumeHash/types";
import { getHash } from "../../../core/services/hashService/getHash/actions";
import { GetHashState } from "../../../core/services/hashService/getHash/types";
import { Constants } from "../../../core/utilities/constants";
import { Helpers } from "../../../core/utilities/helpers";
import { IStore } from "../../../core/utilities/reducers";
import "./HomePage.scss";

interface IProps {
  getHashState: GetHashState;
  getHash: (hash: string) => void;
  consumeHashState: ConsumeHashState;
  consumeHash: (request: ConsumeHashRequest) => void;
}

interface IState {
  isWheelVisible: boolean;
  intervalId?: NodeJS.Timeout;
  mustStartSpinning: boolean;
  winnerPrize?: OfferDto;
}

class HomePage extends Component<IProps> {
  state: IState = {
    isWheelVisible: false,
    intervalId: undefined,
    mustStartSpinning: false,
    winnerPrize: undefined,
  };

  private readonly hash: string;
 

  constructor(props: IProps) {
    super(props);
    const hash = Helpers.getQueryParam("hash");
    this.hash = hash ?? "";
  }

  componentDidMount() {
    this.props.getHash(this.hash);
    console.log(this.state.isWheelVisible)
  }

  componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<{}>,
    snapshot?: any
  ) {
    if (Helpers.isFreshData(prevProps.getHashState, this.props.getHashState)) {
      this.setIntervalWheelCreated();
    }

    if (
      Helpers.isFreshData(
        prevProps.consumeHashState,
        this.props.consumeHashState
      )
    ) {
      if (this.props.getHashState.data) {
        const initData = this.getWheelInitDataFromHashDetail(
          this.props.getHashState.data
        );
        const winnerPrize: OfferDto =
          this.props.getHashState.data.offers[initData.winnerIndex];
        this.dispatchWheelTurnedEvent();
        this.setState({ winnerPrize });
      } else {
        alert("Hash detail not defined after consume!");
      }
    }
  }

  private dispatchWheelTurnedEvent() {
    try {
      (window as any).webkit.messageHandlers.wheelTurned.postMessage(
        JSON.stringify({ status: "ok" })
      );
    } catch (e) {}
    try {
      (window as any).JSBridge.wheelTurned();
    } catch (e) {}
  }

  private handleStart(): void {
    this.setState({ mustStartSpinning: true });
  }

  private handleFinish(): void {
    this.props.consumeHash({ hash: this.hash });
  }

  private getWheelInitDataFromHashDetail(
    hashDetail: HashDetailDto
  ): WheelInitData {
    const data: WheelData[] = [];
    let winnerIndex: number = 0;
   
    return { data, winnerIndex };
  }

  private setIntervalWheelCreated(): void {
    const intervalId = setInterval(() => {
      const wheelPointer = document?.getElementsByTagName("IMG")[0];
      if (wheelPointer) {
        this.wheelCreated(wheelPointer);
      }
    }, 1);
    this.setState({ intervalId });
  }

  private wheelCreated(wheelPointer: Element): void {
    wheelPointer.setAttribute("src", pointer);
    if (this.state.intervalId) {
      clearInterval(this.state.intervalId);
      setTimeout(() => {
        this.setState({ isWheelVisible: true });
      }, 1000);
    }
  }

  private renderWheel(hashDetail: HashDetailDto): ReactNode {

    const initData = this.getWheelInitDataFromHashDetail(hashDetail);
    return (
      <div
        className={`wheel-wrapper `}
      >
        <Wheel4p
          isConsumeLoading={this.props.consumeHashState.loading}
          mustStartSpinning={this.state.mustStartSpinning}
          wheelData={initData.data}
          hashData={this.props.getHashState.data}
          winnerIndex={initData.winnerIndex}
          callbackSpin={() => this.handleStart()}
          callbackFinished={() => this.handleFinish()}
        />
      </div>
    );
  }




  private renderContent(): ReactNode {
    if (this.props.getHashState.loading) {
      return <Loading fontSize={100} />;
    } else if (this.props.getHashState.data) {
      return (
        <React.Fragment>
          {this.renderWheel(this.props.getHashState.data)}
        </React.Fragment>
      );
    }
    return <React.Fragment />;
  }

  render() {
    return (
      <div
        id="home-page"
        className={`page ${this.state.mustStartSpinning && "spinning"}`}
      >
        <div className="page-content">
          {this.renderContent()}
        </div>
      </div>
    );
  }

  componentWillUnmount() {
    if (this.state.intervalId) {
      clearInterval(this.state.intervalId);
    }
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      getHash,
      consumeHash,
    },
    dispatch
  );
};
const mapStateToProps = (store: IStore) => {
  return {
    getHashState: store.getHash,
    consumeHashState: store.consumeHash,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
